import { useContext, useState } from "react";
import WorkFlowModal from "./WorkFlowModal";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import WorkFlowFormModal from "../WorkFlowFormModal/WorkFlowFormModal";
import { generateEditInitialValues } from "./utils/function";

const ViewForm = ({isOpen, setIsOpen, initialValues,handleGetData} : any) => {
  const { toastNotify } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  const submitForm = async (values: any, resetForm: any) => {
    try {
    setLoading(true);
    if (values) {
      const response: any = await appRequest("workflow", "create", values)
      if (response.status === "success") {
        toastNotify({
          title: `Workflow Created successfully`,
          message: response.message || "Something went wrong.",
          type: "success",
        });
        handleGetData()
        resetForm()
        handleCloseModal()
      } else {
        toastNotify({
          title: `Error getting the workflow.`,
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    }
    } catch (err: any) {
      console.log(err?.message)
      toastNotify({
        title: `Error getting the workflow.`,
        message: err.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false)
  };

  return (
    <>
      <WorkFlowFormModal
        type="View"
        isOpen={isOpen}
        onClose={handleCloseModal}
        initialValues={generateEditInitialValues({...initialValues,...initialValues.values})}
        loading={loading}
        submitForm={submitForm}
        showError={showError}
        setShowError={setShowError}
      />
    </>
  );
};

export default ViewForm;